import {hoistCmp} from '@xh/hoist/core';
import {button, ButtonProps} from '@xh/hoist/desktop/cmp/button';
import {Icon, IconProps} from '@xh/hoist/icon';
import './AiButton.scss';

export interface AiButtonProps extends Omit<ButtonProps, 'minimal' | 'intent'> {
    /** True while what the button opens is showing - the button is then filled. */
    active?: boolean;
    /** True while the AI is working - the border shimmers. */
    busy?: boolean;
}

/** The AI sparkles, in the AI colors - mark every AI entry point with it. */
export const aiIcon = (opts: IconProps = {}) => Icon.sparkles({prefix: 'fas', className: 'rzx-ai-icon', ...opts});

/**
 * A button that opens or runs an AI feature. All of them share one look - a violet to fuchsia
 * gradient, filled while active - so it stands apart from the app's other buttons and reads as AI.
 */
export const aiButton = hoistCmp.factory<AiButtonProps>({
    model: false,
    className: 'rzx-ai-button',
    render({active, busy, className, icon, ...rest}) {
        const classes = [className, active && 'rzx-ai-button--active', busy && 'rzx-ai-button--busy', !rest.text && 'rzx-ai-button--icon-only'];
        return button({
            icon: icon ?? aiIcon(),
            minimal: true,
            className: classes.filter(Boolean).join(' '),
            ...rest
        });
    }
});
